import { FormControlLabel } from '@mui/material'
import { ReactElement } from 'react'
import { Control, Controller, FieldError, Path } from 'react-hook-form'
import SelectMui, { TSelectMui } from './SelectMui'

interface IArtisanForm<T> {
  control: Control<T>
  name: Path<T>
  label?: string
  error?: FieldError
  required?: boolean
  endAdornment?: JSX.Element
}

export default function SelectMuiControl<T>({
  control,
  name,
  label,
  error,
  required = false,
  endAdornment,
  items,
}: Readonly<IArtisanForm<T>> & Omit<TSelectMui, 'error'>): ReactElement {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <SelectMui
          label={label}
          // @ts-expect-error
          value={field?.value}
          onChange={(value) => {
            field.onChange(value)
          }}
          items={items}
          error={!!error}
          helperText={error?.message ?? ''}
          fullWidth
          InputProps={{
            ...(endAdornment && { endAdornment }),
          }}
        />
      )}
    />
  )
}
